import axiosInstance from 'api/axiosInstance';

export const getDispatchPhoneNumber = async (): Promise<string> => {
	let url = '/Project/WebService/CANDispatch.asmx/GetDispatchPhoneNumber';
	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}
	const response = await axiosInstance.get(url);
	if (response.status !== 200) {
		throw new Error('Error fetching phone numbers');
	}
	return response.data;
};
